/**
 * Navigation
 */

import {
	lockBodyScrolling,
	unlockBodyScrolling
} from '../../../shared/utils/scroll';

import SelectorEngine from '../../../shared/dom/selector-engine';
import Manipulator from '../../../shared/dom/manipulator';
import EventHandler from '../../../shared/dom/event-handler';

import Nav from '../../../shared/components/nav';
import Drawer from '../../../shared/components/drawer';
import {isElement} from '../../../shared/utils/is';
import {getInlineConfig} from '../../utils';

import SubMenu from './elements/sub';

// -------
// Private
// -------

const NAME      = 'menu';
const DATA_KEY  = `ifab.${NAME}`;
const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY    = '.data-api';

const pageMenu  = SelectorEngine.findOne('#page-menu-drawer');

/**
 * Drawer (Navigationsoverlay)
 */
const setupDrawer = () => {
	const trigger = SelectorEngine.findOne('[aria-controls="page-menu-drawer"]');
	const drawer  = new Drawer(pageMenu, {
		closeButton: 0,
		onShow     : function() {
			Manipulator.addClass(trigger, '-active');
		},
		onHidden   : () => {
			Manipulator.removeClass(trigger, '-active');
		}
	});

	EventHandler.on(trigger, 'click.ifab.pageMenuDrawer', (event) => {
		event.preventDefault();
		event.stopPropagation();

		if (event.delegateTarget.classList.contains('-active')) {
			drawer.hide();
		} else {
			drawer.show();
		}
	});
};

/**
 * Initialisierung der eigentlichen Navigationsliste.
 */
const navigation = () => {
	const nav    = SelectorEngine.findOne('#main-nav', pageMenu);
	const config = getInlineConfig('nav-slider', pageMenu);

	if(!nav) {
		return;
	}

	Manipulator.addClass(nav, 'slide-menu');

	const slideNav = new SlideMenu(nav, {
		backLinkBefore  : '<i class="far fa-chevron-left"></i>',
		submenuLinkAfter: '<i class="far fa-chevron-right"></i>',
		media           : config
	});

	EventHandler.on(nav, 'click', '.nav-link', (event) => {
		event.preventDefault();
		event.stopPropagation();

		const link   = event.delegateTarget;
		const target = event.target;
		const pageId = Manipulator.getDataAttribute(link, 'page');

		if(link.classList.contains('-has-sub')) {
			let navItem = SelectorEngine.parents(target, '.nav-item')[0];
			let subMenu = SelectorEngine.findOne('.nav-list', navItem);

			slideNav.navigateTo(subMenu);
		} else {
			window.location.href = event.delegateTarget.getAttribute('href');
		}
	});
};

// -------
// Public
// -------

const menu = () => {
	if (pageMenu) {
		setupDrawer();
		navigation();
		SubMenu();
	}
};

// Export
export default menu;
